import type DxfArrayScanner from 'dxf-parser/dist/DxfArrayScanner.js'
import type { IGroup } from 'dxf-parser/dist/DxfArrayScanner.js'
import type { IEntity, IPoint } from 'dxf-parser/dist/entities/geomtry.js'
import { AUTO_CAD_COLOR_INDEX } from '@/plugins/cad/module/parser/autoCadColorIndex'

/** 将 ACI 颜色索引转换为 RGB 真彩色值。 */
export function getAcadColor(index: number): number | undefined {
  return AUTO_CAD_COLOR_INDEX[index]
}

/** 从当前 DXF 组码位置读取二维或三维点。 */
export function parsePoint(scanner: DxfArrayScanner): IPoint {
  const point = {} as IPoint
  scanner.rewind()
  let curr = scanner.next()
  let code = curr.code
  point.x = curr.value as number

  code += 10
  curr = scanner.next()
  if (curr.code !== code) {
    throw new Error(`Expected code for point value to be ${code} but got ${curr.code}.`)
  }
  point.y = curr.value as number

  code += 10
  curr = scanner.next()
  if (curr.code !== code) {
    scanner.rewind()
    return point
  }
  point.z = curr.value as number
  return point
}

/** 解析所有 DXF 实体共享的属性组码。 */
export function checkCommonEntityProperties(
  entity: IEntity,
  curr: IGroup,
  scanner: DxfArrayScanner
): boolean {
  switch (curr.code) {
    case 0:
      entity.type = curr.value as string
      break
    case 5:
      entity.handle = curr.value as number
      break
    case 6:
      entity.lineType = curr.value as string
      break
    case 8:
      entity.layer = curr.value as string
      break
    case 48:
      entity.lineTypeScale = curr.value as number
      break
    case 60:
      entity.visible = curr.value === 0
      break
    case 62: {
      const colorIndex = curr.value as number
      entity.colorIndex = colorIndex
      entity.color = getAcadColor(Math.abs(colorIndex)) as number
      break
    }
    case 67:
      entity.inPaperSpace = curr.value !== 0
      break
    case 100:
      break
    case 101:
      while (curr.code !== 0) {
        curr = scanner.next()
      }
      scanner.rewind()
      break
    case 330:
      entity.ownerHandle = curr.value as string
      break
    case 347:
      entity.materialObjectHandle = curr.value as number
      break
    case 370:
      entity.lineweight = curr.value as IEntity['lineweight']
      break
    case 420:
      entity.color = curr.value as number
      break
    case 1000:
      entity.extendedData ||= {} as IEntity['extendedData']
      entity.extendedData.customStrings ||= []
      entity.extendedData.customStrings.push(curr.value as string)
      break
    case 1001:
      entity.extendedData ||= {} as IEntity['extendedData']
      entity.extendedData.applicationName = curr.value as string
      break
    default:
      return false
  }
  return true
}
